module.exports = __webpack_public_path__ + "static/media/image5.7be509c2.jpg";